import Accordion from 'components/global/Accordion'
import Coverages from './Coverages'
import Limit from './Limit'
import Policyholders from './Policyholders'

export default function Policy({ policy }) {
  return (
    <div className="w-full rounded-lg bg-white shadow-lg">
      <div className="space-y-2 rounded-t-lg bg-purple p-6 sm:flex sm:items-center sm:justify-between sm:space-y-0 sm:space-x-4">
        <div>
          <h3 className="text-2xl font-semibold capitalize text-white">
            {policy?.line.replace(/_/g, ' ')} Policy
          </h3>
        </div>
        <div>
          <p className="text-purple-200">Policy #{policy?.masked_number}</p>
        </div>
      </div>
      <div className="flex justify-between p-6 text-gray-800">
        <Policyholders policyholders={policy.policyholders} />
      </div>
      <hr />
      <div className="space-y-4 p-6">
        {policy.premium && (
          <>
            <div className="flex justify-between">
              <h3 className="mb-2 text-lg font-semibold text-gray-800">
                Policy premium
              </h3>
              <div className="flex items-center space-x-4 text-gray-800">
                <Limit limit={policy.premium} />
              </div>
            </div>
            <hr className="-mx-6" />
          </>
        )}
        <Accordion
          title={(policy.line == 'personal_auto' || policy.line == 'motorcycle') ? 'Vehicles' : 'Locations'}
          items={(policy.vehicles || policy.locations).map((item) => ({
            title:
                (policy.line == 'personal_auto' || policy.line == 'motorcycle') ? (
                <div>
                  {item.year} {item.make} {item.model} ({item.vin})
                </div>
              ) : (
                <div>
                  {item.address.line1} {item.address.line2} {item.address.city},{' '}
                  {item.address.state} {item.address.postal_code}
                </div>
              ),
            content: <Coverages coverages={item.coverages} />,
          }))}
        />
      </div>
      <hr />
      <div className="grid p-6 sm:grid-cols-2 sm:gap-10">
        <div className="flex flex-1 justify-between space-x-10">
          <div>
            <h3 className="font-semibold">Status:</h3>
            <h3 className="font-semibold">Inception date:</h3>
          </div>
          <div className="flex flex-col items-end">
            <p className="capitalize">{policy?.status}</p>
            <p>{policy?.inception_date || 'n/a'}</p>
          </div>
        </div>
        <div className="flex flex-1 justify-between space-x-10">
          <div>
            <h3 className="font-semibold">Expiration date:</h3>
            <h3 className="font-semibold">Cancellation date:</h3>
          </div>
          <div className="flex flex-col items-end">
            <p>{policy?.expiration_date || 'n/a'}</p>
            <p>{policy?.cancellation_date || 'n/a'}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
